import React from 'react'

import { withImageListItem } from '../image-edit/ImageItem'
import AddLinkListItemForm from './AddLinkListItemForm'

class AddLinkListItem extends React.Component {
  render() {
    return <AddLinkListItemForm {...this.props} />
  }
}

export default withImageListItem(AddLinkListItem)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/AddLinkListItem.js